import { Injectable } from "@angular/core";

type HttpHeader = {
    [key: string]: string;
};

@Injectable({
    providedIn: "root"
})
export class DefaultHeaderService {

    headers: HttpHeader = {};
}
